package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

class GetMyRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String? = null): RouteSummary = repository.getMyRoute(routeId)
}
